/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free URL slug generator. Turn any title or text into a clean, SEO-friendly URL slug with accents stripped. Runs in your browser.`)
};

const es_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de slug de URL gratuito. Convierte cualquier título o texto en un slug de URL limpio y amigable con SEO sin acentos. Se ejecuta en tu navegador.`)
};

const de_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser URL-Slug-Generator. Verwandeln Sie jeden Titel oder Text in einen sauberen, SEO-freundlichen URL-Slug mit entfernten Akzenten. Läuft in Ihrem Browser.`)
};

const nl_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis URL slug generator. Zet elke titel of tekst om in een schone, SEO-vriendelijke URL slug met verwijderde accenten. Werkt in uw browser.`)
};

const fr_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de slug URL gratuit. Transformez n'importe quel titre ou texte en un slug URL propre et optimisé pour le SEO, avec accents supprimés. Fonctionne dans votre navigateur.`)
};

const it_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di slug URL gratuito. Trasforma qualsiasi titolo o testo in uno slug URL pulito e SEO-friendly con accenti rimossi. Funziona nel tuo browser.`)
};

const pt_br2_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de slug de URL gratuito. Transforme qualquer título ou texto em um slug de URL limpo e amigável para SEO com acentos removidos. Funciona no seu navegador.`)
};

const pt_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de slugs de URL gratuito. Transforme qualquer título ou texto num slug de URL limpo e otimizado para SEO com acentos removidos. Funciona no seu navegador.`)
};

const ja_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のURLスラグジェネレータ。任意のタイトルやテキストをクリーンなSEOフレンドリーなURLスラグに変換し、アクセント記号を削除します。ブラウザで実行されます。`)
};

const zh_sg_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的 URL slug 生成器。将任意标题或文本转换为简洁、对 SEO 友好的 URL slug，并去除重音符号。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_tool_description", locale)
	if (locale === "en") return en_sg_tool_description(inputs)
	if (locale === "es") return es_sg_tool_description(inputs)
	if (locale === "de") return de_sg_tool_description(inputs)
	if (locale === "nl") return nl_sg_tool_description(inputs)
	if (locale === "fr") return fr_sg_tool_description(inputs)
	if (locale === "it") return it_sg_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_sg_tool_description(inputs)
	if (locale === "pt") return pt_sg_tool_description(inputs)
	if (locale === "ja") return ja_sg_tool_description(inputs)
	return zh_sg_tool_description(inputs)
};